import React from "react"
import { Disclosure } from "@headlessui/react"
import { ChevronDownIcon } from "@heroicons/react/24/outline"
import FooterNoteAndCTA from "../footernote/FooterNoteAndCTA"
import { Helmet } from "react-helmet"

function classNames(...classes) {
	return classes.filter(Boolean).join(" ")
}

function Faq({ faq }) {
	return (
		<Disclosure
			as="div"
			className="pt-6"
		>
			{({ open }) => (
				<>
					<dt className="text-lg ">
						<Disclosure.Button className="text-left w-full flex justify-between items-start text-gray-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary-500">
							<span className="font-medium text-gray-900">{faq.question}</span>
							<span className="ml-6 h-7 flex items-center">
								<ChevronDownIcon
									className={classNames(open ? "-rotate-180" : "rotate-0", "h-6 w-6 transform")}
									aria-hidden="true"
								/>
							</span>
						</Disclosure.Button>
					</dt>
					<Disclosure.Panel
						as="dd"
						className="mt-2 pr-12"
					>
						<div
							className="text-base text-gray-500"
							dangerouslySetInnerHTML={{
								__html: faq.answer.childMarkdownRemark.html,
							}}
						></div>
					</Disclosure.Panel>
				</>
			)}
		</Disclosure>
	)
}

function FAQs({ faqs }) {
	return (
		<dl className=" mx-auto mt-12 space-y-6 divide-y divide-gray-200">
			{faqs.map((faq) => (
				<Faq
					faq={faq}
					key={faq.question}
				/>
			))}
		</dl>
	)
}

function FaqsWithHeadingAndCTA({ heading, faqs, isfooter, footnote, ctaText, ctaLink }) {
	const getFAQObjects = (data) => {
		const value =
			data &&
			data.map((item) => {
				return {
					"@type": "Question",
					name: item.question,
					acceptedAnswer: {
						"@type": "Answer",
						text: item.answer.answer,
					},
				}
			})
		return JSON.stringify(value)
	}

	return (
		<>
			<Helmet>
				<script type="application/ld+json">
					{`
            {
              "@context": "https://schema.org",
              "@type": "FAQPage",
              "mainEntity": ${getFAQObjects(faqs)}
            }
          `}
				</script>
			</Helmet>

			<div className="max-w-7xl mx-auto px-4 sm:px-6">
				<div className="max-w-3xl mx-auto divide-y-2 divide-gray-200">
					<h1 className="text-center font-bold text-3xl lg:text-4xl font-bold tracking-tight text-gray-900">
						{heading}
					</h1>
					<FAQs faqs={faqs} />
				</div>
				{isfooter && (
					<FooterNoteAndCTA
						footnote={footnote}
						ctaText={ctaText}
						ctaLink={ctaLink}
					/>
				)}
			</div>
		</>
	)
}

export { FaqsWithHeadingAndCTA, FAQs, Faq }
